import React, { Component } from 'react';
import Product from './Product'

class ProductGrid extends Component {

  render() {
    return (
      <div className="container">
        <div className="ProductGrid">
          {
            this.props.products.map(item => {
              if (item.title.includes("Olivolja")) {
                return <Product
                          key={item.id}
                          cart={this.props.cart}
                          theMonth={this.props.theMonth}
                          addToCart={this.props.addToCart}
                          reduceQuantity={this.props.reduceQuantity}
                          {...item}/>
              }
            })
          }
        </div>
        <div className="ProductGrid-divider">
          <div>
          </div>
          <p>Exklusive Olivolja</p>
          <div>
          </div>
        </div>
        <div className="ProductGrid" style={{padding: "0"}}>
          {
            this.props.products.map(item => {
              if (!item.title.includes("Olivolja")) {
                return <Product
                          key={item.id}
                          cart={this.props.cart}
                          theMonth={this.props.theMonth}
                          addToCart={this.props.addToCart}
                          reduceQuantity={this.props.reduceQuantity}
                          {...item}/>
              }
            })
          }
        </div>
      </div>
    );
  }
}

export default ProductGrid;



// WEBPACK FOOTER //
// ./src/components/ProductGrid.jsx